module.exports = __webpack_public_path__ + "img/mci_logo_square.5c225dd8.png";